import Image from 'next/image';
import { NoParcelsAddedYetWrapper, NoParcelsContainer, NoParcelsText } from './NoParcels.styles';
import { useNoParcelsCopy } from './hooks';

const NO_PARCELS_IMAGE_SIZE = 32;

export const NoParcels: React.FC = ({ children }) => {
  return (
    <NoParcelsContainer>
      <Image
        alt='No parcels image'
        src='/images/icons/parcel_tracking.svg'
        width={NO_PARCELS_IMAGE_SIZE}
        height={NO_PARCELS_IMAGE_SIZE}
      />
      <NoParcelsText>{children}</NoParcelsText>
    </NoParcelsContainer>
  );
};

export const NoParcelAddedYet = () => {
  const { noParcelsAdded } = useNoParcelsCopy();
  return (
    <NoParcelsAddedYetWrapper>
      <NoParcels>{noParcelsAdded}</NoParcels>
    </NoParcelsAddedYetWrapper>
  );
};

export const NoParcelsFound = () => {
  const { noParcelsFound } = useNoParcelsCopy();
  return <NoParcels>{noParcelsFound}</NoParcels>;
};
